import { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftjsToHtml from "draftjs-to-html";
import "./editor.css";
import htmlToDraft from "html-to-draftjs";

const MyEditor = ({ note, setNote, index, user }) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const handleEditorStateChange = (value) => {
    setEditorState(value);
    setNote(draftjsToHtml(convertToRaw(value.getCurrentContent())), index);
  };

  useEffect(() => {
    if (note?.length >= 0) {
      // const html = note;
      // const contentBlock = htmlToDraft(html);
      // const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);

      // setEditorState(EditorState.createWithContent(contentState))
      // let oldEditorState = editorState
      // const oldSelectionState = oldEditorState.getSelection();

      // create new editorState from content
      let content = note;
      let contentBlock = htmlToDraft(content || "");
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      const newEditorState = EditorState.createWithContent(contentState);

      // update cursor position base on old selection state
      let updateSelection = newEditorState.getSelection();

      // check whether editor on focus, if onforcus use forceSelection to manually update the posiition
      // if not on focus, use acceptSelection
      let newEditorStateWithSelection = EditorState.forceSelection(
        newEditorState,
        updateSelection
      );
      // if (oldSelectionState.getHasFocus()) {
      //   newEditorStateWithSelection = EditorState.forceSelection(newEditorState, newEditorState.getSelection().merge(updateSelection))
      // } else {
      //   newEditorStateWithSelection = EditorState.acceptSelection(newEditorState, newEditorState.getSelection().merge(updateSelection))
      // }

      setEditorState(newEditorStateWithSelection);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Editor
      editorState={editorState}
      // defaultEditorState={editorState}
      onEditorStateChange={handleEditorStateChange}
      toolbarClassName="demo-toolbar-custom"
      wrapperClassName="demo-wrapper"
      editorClassName="demo-editor-custom"
      toolbar={{
        options: ["link", "inline"],
        inline: { options: ["bold"] },
        link: {
          inDropdown: false,
          showOpenOptionOnHover: true,
          defaultTargetOption: "_self",
          options: ["link"],
        },
      }}>
      <textarea
        disabled
        value={draftjsToHtml(convertToRaw(editorState.getCurrentContent()))}
      />
    </Editor>
  );
};

export default MyEditor;
